









import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Locations, UserState, Templates } from './models'
import { TemplatePicker, LocationPicker, LoginForm } from './components'
import { Route } from 'vue-router'

@Component({
  components: { LoginForm, LocationPicker, TemplatePicker },
})
export default class App extends Vue {
  UserState = UserState
  Locations = Locations
  Templates = Templates

  protected beforeCreate() {
    UserState.SETUP_AUTH_TOKEN()
  }

  protected mounted() {
    this.onRouteChanged(this.$route, this.$route)
  }

  get ready() {
    return Locations.entitiesLoaded && Templates.entitiesLoaded
  }

  @Watch('$route') private onRouteChanged(to: Route, from: Route) {
    const { location_id, template_id, auth_token } = to.query
    if (location_id) { Locations.SET_ACTIVE_LOCATION_ID(Number(location_id)) }
    if (template_id) { Templates.SET_ACTIVE_TEMPLATE_ID(Number(template_id)) }
    if (auth_token) { UserState.SETUP_AUTH_TOKEN(Array.isArray(auth_token) ? auth_token.join() : auth_token) }
  }
}
